module.exports = __webpack_public_path__ + "img/all-bg.ed69e5da.png";